import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { ClickoutUrl } from '@/helpers/clickout-helper';

import { OfferLocation } from '@/helpers/offer-helper';
import { SnowplowContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';
import { computed, ref } from 'vue';
import { ObjectType } from '@/@types/graphql-types';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { isTitleSeason } from '@/pages/titleDetailV1/v1/composables/useTitleDetailInfo';
import { observableOptions, useOfferImpressionTracking } from '@/helpers/composables/useOfferImpressionTracking';
import { useProviderPromotion } from '@/helpers/provider-promotion';
import DisclaimerButton from '@/features/buybox/components/DisclaimerButton.vue';

import { useAppStore } from '@/stores/pinia/useAppStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderPromotionOffer',
  props: {
    title: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, additionalContexts: SnowplowContext[] };



const { country } = storeToRefs(useLanguageStore());
const { xServeTrack } = storeToRefs(useAppStore());

const { providerPromotion: promotion, isPromotionOffer } = useProviderPromotion(() => props.title);

// we can be reasonably sure there is an offer because the parent would check
// nonetheless, there's an extra check in the template
const offer = computed(() => props.title.offers.find(offer => isPromotionOffer(offer)));

const showDisclaimerButton = computed(() => promotion.value?.disclaimerText != null);

const titleObjectId = computed(() => (isTitleSeason(props.title) ? props.title.show?.objectId : props.title.objectId));
const titleObjectType = computed(() => (isTitleSeason(props.title) ? ObjectType.Show : props.title.objectType));

const titleContext = computed(() => new SnowplowTitleContextGraphql(titleObjectId.value, titleObjectType.value));

const { onIntersection } = useOfferImpressionTracking({
	additionalContexts: () => props.additionalContexts,
});

const clickOutUrl = computed(() => {
	const clickoutOffer = promotion.value?.url ? { ...offer.value, standardWebURL: promotion.value.url } : offer.value;
	const skipRedirect = !!promotion.value?.url;
	const isATVPlus = offer.value?.package?.packageId === 350;

	const url = new ClickoutUrl(clickoutOffer)
		.setTitleSourceId(props.title.id)
		.skipYieldOptimization(isATVPlus)
		.skipRedirect(skipRedirect)
		.addContexts(titleContext.value)
		.set('uct_country', country.value)
		.setForTracking('offerLocation', OfferLocation.BACKDROP)
		.updateContext('ClickoutContextGraphql', 'clickoutType', 'promoted')
		.updateContext('ClickoutContextGraphql', 'placement', 'backdrop')
		.updateContext('TitleContextGraphql', 'jwRawEntityId', props.title.id)
		.setCanary(xServeTrack.value);

	if (['dnp', 'hst'].includes(offer.value?.package?.shortName || '')) {
		const tag = `disney-${country.value.toLowerCase()}-promo`;
		url.set('uct_ctag', tag);
	}

	/**
	 * BINGE - note binge UCT2 rules are for a specific campagin - the next one may need a url update
	 */

	return url;
});

const observeVisibilityOptions = computed(() => {
	return {
		callback: onVisibilityChanged,
		...observableOptions,
	};
});

function onVisibilityChanged(isVisible: boolean) {
	if (!isVisible) return;

	onIntersection(clickOutUrl.value, isVisible);
}

function handleClickout() {
	if (offer.value == null) return;
}

return { __sfc: true,props, country, xServeTrack, promotion, isPromotionOffer, offer, showDisclaimerButton, titleObjectId, titleObjectType, titleContext, onIntersection, clickOutUrl, observeVisibilityOptions, onVisibilityChanged, handleClickout, ProviderIcon, DisclaimerButton }
}

})